import { render, staticRenderFns } from "./SearchBuildingByAddress.vue?vue&type=template&id=d4ae531a&scoped=true&"
import script from "./SearchBuildingByAddress.vue?vue&type=script&lang=js&"
export * from "./SearchBuildingByAddress.vue?vue&type=script&lang=js&"
import style0 from "./SearchBuildingByAddress.vue?vue&type=style&index=0&id=d4ae531a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae531a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
